import { render, staticRenderFns } from "./ViewEdit.vue?vue&type=template&id=2576fb7e&scoped=true&v-if=data&"
import script from "./ViewEdit.vue?vue&type=script&lang=js&"
export * from "./ViewEdit.vue?vue&type=script&lang=js&"
import style0 from "./ViewEdit.vue?vue&type=style&index=0&id=2576fb7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2576fb7e",
  null
  
)

export default component.exports